import helper from '@/shared/helper';
import mixin from '@/shared/mixins';
import bus from '@/bus';

function interceptor(request, next) {
	const userToken = helper.methods.getToken();
	if (this.$route.name !== 'login') {
		const urlRequest = request.url;
		if (!urlRequest.includes(process.env.PERU_DATOS_URL)) {
			if (urlRequest.includes(process.env.PRODUCTS_URL)
					|| urlRequest.includes(process.env.SALES_URL)) {
				if (!request.headers.get('authorization')) {
					request.headers.set('Authorization', `Bearer ${process.env.COMPANY_TOKEN}`);
				}
			} else {
				request.headers.set('Authorization', `Bearer ${userToken}`);
			}
		}
	}
	bus.$emit('show-progress', true);
	return next((response) => {
		bus.$emit('show-progress', false);
		const status = response.status;
		const loginRoute = { name: 'login' };
		if (status === 401) {
			this.showNotification('Su sesión expiró.', 'error');
			this.$router.push(loginRoute);
		} else if (status === 403) {
			this.showNotification('No tiene suficientes permisos para realizar ésta acción',
				'error');
		} else if (status === 500) {
			this.showNotification('Ocurrió un error interno en el servidor.',
				'error');
		}
	});
}

export default {
	interceptor,
	mixins: mixin,
};



// WEBPACK FOOTER //
// ./src/resource/index.js